module.exports = __webpack_public_path__ + "static/media/sastra-logo.fa502c6c.png";